import React from 'react';
import { Container, Box } from '@mui/material';
import NavBar from './NavBar';
import Footer from './Footer';

const Layout = ({ children, isAuthenticated, username, handleLogout, handleOpenLogin, handleOpenRegister }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <NavBar
                isAuthenticated={isAuthenticated}
                username={username}
                handleLogout={handleLogout}
                handleOpenLogin={handleOpenLogin}
                handleOpenRegister={handleOpenRegister}
            />
            <Container sx={{ flex: 1, mt: 8 }}>
                {children}
            </Container>
            <Footer />
        </Box>
    );
};

export default Layout;